import { Country, State, City } from "country-state-city";

// Get all countries
export const getAllCountries = () => {
  return Country.getAllCountries().map((country) => ({
    value: country.isoCode,
    label: country.name,
    ...country,
  }));
};

// Get states for a country
export const getStatesForCountry = (countryCode) => {
  if (!countryCode) return [];

  return State.getStatesOfCountry(countryCode).map((state) => ({
    
    value: state.isoCode,
    label: state.name,
    ...state,
  }));
};

// Get cities for a state
export const getCitiesForState = (countryCode, stateCode) => {
  if (!countryCode || !stateCode) return [];
  return City.getCitiesOfState(countryCode, stateCode).map((city) => ({
    value: city.name,
    label: city.name,
    ...city,
  }));
};

// Get country information by code
export const getCountryByCode = (countryCode) => {
  return Country.getCountryByCode(countryCode);
};

// Get state information by code
export const getStateByCode = (countryCode, stateCode) => {
  return State.getStateByCodeAndCountry(stateCode, countryCode);
};

// Format the data for select dropdown options
export const formatSelectOptions = (data) => {
  return data.map((item) => ({
    value: item.value,
    label: item.label,
  }));
};
